<template>
  <div id="app">
    <div>
      <!-- 表单头部 -->
      <el-form
        style="margin-buttom: 15px"
        :inline="true"
        :model="schoolList"
        class="demo-form-inline"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model="schoolList.name"
            placeholder="请输入学校名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <!-- 表格区域 -->
      <el-table
        :data="schoolData"
        border
        :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
        :row-style="{ height: '48px' }"
        stripe
        style="width: 100%; margin-bottom: 20px"
      >
        <el-table-column align="center" type="index" width="50">
        </el-table-column>
        <el-table-column align="center" prop="province" label="省">
        </el-table-column>
        <el-table-column align="center" prop="city" label="市">
        </el-table-column>
        <el-table-column align="center" prop="county" label="区县">
        </el-table-column>
        <el-table-column
          align="center"
          prop="name"
          width="260"
          label="学校名称"
        >
        </el-table-column>
        <el-table-column align="center" prop="code" label="学校识别码">
        </el-table-column>
        <el-table-column align="center" prop="orgName" label="所属单位">
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="注册时间">
        </el-table-column>
        <el-table-column align="center" width="120" label="是否为基地校">
          <template slot-scope="scope">
            <el-tooltip
              :content="scope.row.isPay == 0 ? '普通学校' : '基地校'"
              placement="top"
            >
              <el-switch
                v-model="scope.row.isPay"
                active-value="1"
                inactive-value="0"
                @change="handleBaseChange(scope.row)"
              >
              </el-switch>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <div slot-scope="scope">
            <el-button @click="setCourse(scope.row)" type="text"
              >设置课程</el-button
            >
            <el-button @click="resetPassword(scope.row.id)" type="text"
              >重置密码</el-button
            >
          </div>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        @current-change="currentChange"
        :total="schoolList.totalCount"
      ></el-pagination>
      <!-- 弹框区域 -->
      <el-dialog
        title="设置课程"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="1400px"
        top="50px"
        :before-close="handleClose"
      >
        <div class="dialogFlex">
          <div class="dlog_left">
            <!-- 头部筛选区域 -->
            <div style="margin-bottom: 15px">已选课程</div>
            <el-form
              style="margin-buttom: 15px"
              :inline="true"
              :model="courseTrue"
              class="demo-form-inline"
            >
              <el-form-item>
                <el-select
                  clearable
                  style="width: 120px"
                  @change="leftChange"
                  size="small"
                  v-model="courseTrue.type"
                  placeholder="课程类型"
                >
                  <el-option
                    v-for="item in classify"
                    :key="item.id"
                    :label="item.classifyName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input
                  size="small"
                  style="width: 180px"
                  v-model="courseTrue.name"
                  placeholder="请输入课程名称"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="queryCourseTrue"
                  >查询</el-button
                >
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="leftOpe"
                  >一键移除</el-button
                >
              </el-form-item>
            </el-form>
            <!-- 表格区域 -->
            <el-table
              @selection-change="leftSelectionChange"
              :data="trueLeft"
              ref="leftTable"
              :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
              :row-style="{ height: '48px' }"
              stripe
              style="width: 100%"
            >
              <el-table-column align="center" type="selection" label="">
              </el-table-column>
              <el-table-column align="center" label="课程名称">
                <div slot-scope="scope">
                  <span style="color: #2a8bf8">{{ scope.row.courseName }}</span>
                </div>
              </el-table-column>
              <el-table-column
                align="center"
                prop="createTime"
                label="开始时间"
              >
              </el-table-column>
              <el-table-column align="center" prop="classifyName" label="分类">
              </el-table-column>
              <el-table-column align="center" label="课程类型">
                <div slot-scope="scope">
                  <span>{{
                    scope.row.courseTypeid == 1 ? "直播" : "点播"
                  }}</span>
                </div>
              </el-table-column>
              <el-table-column
                align="center"
                prop="courseSpeaker"
                label="主讲人"
              >
              </el-table-column>
              <el-table-column fixed="right" align="center" label="操作">
                <div slot-scope="scope">
                  <el-button
                    type="text"
                    @click="operationLeft(scope.row.courseId)"
                    v-if="leftData.indexOf(scope.row.courseId) == -1"
                    >移除</el-button
                  >
                  <el-button
                    type="text"
                    style="color: #dd6058"
                    @click="leftCancel(scope.row.courseId)"
                    v-else
                    >取消</el-button
                  >
                </div>
              </el-table-column>
            </el-table>
            <!-- 分页区域 -->
            <el-pagination
              background
              style="margin-top: 15px"
              layout="total, prev, pager, next, jumper"
              @current-change="trueChange"
              :total="courseTrue.totalCount"
            ></el-pagination>
          </div>
          <div class="dlog_centent">
            <i
              style="transform: scale(3); color: #409eff"
              class="el-icon-d-arrow-left"
            ></i>
            <i
              style="transform: scale(3); color: #409eff"
              class="el-icon-d-arrow-right"
            ></i>
          </div>
          <div class="dlog_right">
            <div style="margin-bottom: 15px">未选课程</div>
            <!-- 头部筛选区域 -->
            <el-form
              style="margin-buttom: 15px"
              :inline="true"
              :model="courseTrue"
              class="demo-form-inline"
            >
              <el-form-item>
                <el-select
                  clearable
                  style="width: 120px"
                  @change="rightChange"
                  size="small"
                  v-model="courseFalse.type"
                  placeholder="课程类型"
                >
                  <el-option
                    v-for="item in classify"
                    :key="item.id"
                    :label="item.classifyName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input
                  size="small"
                  style="width: 180px"
                  v-model="courseFalse.name"
                  placeholder="请输入学校名称"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="queryCourseFalse"
                  >查询</el-button
                >
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="rightOpe"
                  >一键加入</el-button
                >
              </el-form-item>
            </el-form>
            <!-- 表格区域 -->
            <el-table
              :data="falseRight"
              @selection-change="rightSelectionChange"
              ref="rightTable"
              :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
              :row-style="{ height: '48px' }"
              stripe
              style="width: 100%"
            >
              <el-table-column align="center" type="selection" label="">
              </el-table-column>
              <el-table-column align="center" label="课程名称">
                <div slot-scope="scope">
                  <span style="color: #2a8bf8">{{ scope.row.courseName }}</span>
                </div>
              </el-table-column>
              <el-table-column
                align="center"
                prop="createTime"
                label="开始时间"
              >
              </el-table-column>
              <el-table-column align="center" prop="classifyName" label="分类">
              </el-table-column>
              <el-table-column align="center" label="课程类型">
                <div slot-scope="scope">
                  <span>{{
                    scope.row.courseTypeid == 1 ? "直播" : "点播"
                  }}</span>
                </div>
              </el-table-column>
              <el-table-column
                align="center"
                prop="courseSpeaker"
                label="主讲人"
              >
              </el-table-column>
              <el-table-column fixed="right" align="center" label="操作">
                <div slot-scope="scope">
                  <!-- <el-button type="text" v-if="rightDataDeal(scope.row.courseId)">加入</el-button> -->
                  <el-button
                    type="text"
                    @click="operationRight(scope.row.courseId)"
                    v-if="rightData.indexOf(scope.row.courseId) == -1"
                    >加入</el-button
                  >
                  <el-button
                    type="text"
                    style="color: #dd6058"
                    @click="rightCancel(scope.row.courseId)"
                    v-else
                    >取消</el-button
                  >
                </div>
              </el-table-column>
            </el-table>
            <!-- 分页区域 -->
            <el-pagination
              background
              style="margin-top: 15px"
              layout="total, prev, pager, next, jumper"
              @current-change="falseChange"
              :total="courseFalse.totalCount"
            ></el-pagination>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as homeApi from "@/api/home";
import { ERR_OK } from "@/api/index";
export default {
  data() {
    return {
      groupId: localStorage.getItem("groupId"),
      schoolId: "",
      formInline: {
        user: "",
        region: "",
      },
      schoolList: {
        curPage: 1,
        pageSize: 10,
        totalCount: 0,
        name: "",
      },
      courseTrue: {
        curPage: 1,
        pageSize: 10,
        totalCount: 0,
        type: "",
        name: "",
      },
      trueLeft: [],
      courseFalse: {
        curPage: 1,
        pageSize: 10,
        totalCount: 0,
        type: "",
        name: "",
      },
      falseRight: [],
      schoolData: [],
      dialogVisible: false,
      classify: [],
      leftData: [],
      rightData: [],
      leftDataQ: [],
      rightDataQ: [],
    };
  },
  created() {
    this.schoolLists();
    this.courseclassify();
  },
  methods: {
    onSubmit() {
      this.schoolLists();
    },
    // 获取学校列表数据
    schoolLists() {
      let params = {
        curPage: this.schoolList.curPage,
        pageSize: this.schoolList.pageSize,
        groupId: this.groupId,
        name: this.schoolList.name,
      };

      homeApi.schoolList(params).then((res) => {
        let list = res.data.data.dataList;
        list.forEach((item) => {
          item.isPay = item.isPay.toString();
        });
        this.schoolData = list;
        this.schoolList.totalCount = res.data.data.totalCount;
      });
    },
    // 页码变化
    currentChange(e) {
      this.schoolList.curPage = e;
      this.schoolLists();
    },
    // dlog关闭
    handleClose() {
      this.dialogVisible = false;
      this.schoolId = "";
    },
    // 弹框
    setCourse(row) {
      this.schoolId = row.id;
      this.courseListTrue();
      this.courseListFalse();
      this.dialogVisible = true;
    },
    // 已选课程
    courseListTrue() {
      let params = {
        schoolId: this.schoolId,
        groupId: this.groupId,
        curPage: this.courseTrue.curPage,
        pageSize: this.courseTrue.pageSize,
        isLimit: 1,
        courseName: this.courseTrue.name,
        courseClassify: this.courseTrue.type,
      };
      homeApi.courseLists(params).then((res) => {
        this.trueLeft = res.data.data.dataList;
        this.courseTrue.totalCount = res.data.data.totalCount;
        if (this.leftDataQ.length !== 0) {
          setTimeout(() => {
            this.leftDataQ.forEach((item) => {
              this.$refs.leftTable.toggleRowSelection(item);
            });
          });
        }
      });
    },
    // 已选课程分页变化
    trueChange(e) {
      this.courseTrue.totalCount = e;
    },
    // 未选课程
    courseListFalse() {
      let params = {
        schoolId: this.schoolId,
        groupId: this.groupId,
        curPage: this.courseFalse.curPage,
        pageSize: this.courseFalse.pageSize,
        isLimit: 0,
        courseName: this.courseFalse.name,
        courseClassify: this.courseFalse.type,
      };
      homeApi.courseLists(params).then((res) => {
        this.falseRight = res.data.data.dataList;
        this.courseFalse.totalCount = res.data.data.totalCount;
        if (this.rightDataQ.length !== 0) {
          setTimeout(() => {
            this.rightDataQ.forEach((item) => {
              this.$refs.rightTable.toggleRowSelection(item);
            });
          });
        }
      });
    },
    // 未选课程分页变化
    falseChange(e) {
      this.courseFalse.totalCount = e;
    },
    // 获取课程分类
    courseclassify() {
      let that = this;
      homeApi
        .courseclassify()
        .then((res) => {
          that.classify = res.data.data;
        })
        .catch(() => {});
    },
    // 名字搜索
    queryCourseFalse() {
      this.courseListFalse();
    },
    queryCourseTrue() {
      this.courseListTrue();
    },
    // 左侧分类变化
    leftChange(e) {
      this.courseTrue.type = e;
      this.courseListTrue();
    },
    rightChange(e) {
      this.courseFalse.type = e;
      this.courseListFalse();
    },
    // 左侧数据选中
    leftSelectionChange(val) {
      // 当前页数据清除
      if (val.length == 0) {
        this.trueLeft.forEach((item, index) => {
          let idx = this.leftData.indexOf(item.courseId);
          if (idx !== -1) {
            this.leftDataQ.splice(idx, 1);
          }
        });
      } else {
        // 数据暂存
        val.forEach((item) => {
          const idx =
            this.leftDataQ.findIndex(
              (items) => items.courseId == item.courseId
            ) == -1;
          if (idx) {
            this.leftDataQ.push(item);
          }
        });
      }
    },
    // 右侧数据选中
    rightSelectionChange(val) {
      if (val.length == 0) {
        // 当前页数据清除
        this.falseRight.forEach((item) => {
          const idx = this.rightDataQ.findIndex(
            (items) => items.courseId == item.courseId
          );
          if (idx !== -1) {
            this.rightDataQ.splice(idx, 1);
          }
        });
      } else {
        // 数据暂存
        val.forEach((item) => {
          const idx =
            this.rightDataQ.findIndex(
              (items) => items.courseId == item.courseId
            ) == -1;
          if (idx) {
            this.rightDataQ.push(item);
          }
        });
      }
    },
    // 一键操作
    leftOpe() {
      this.leftDataQ.forEach((item) => {
        let idx = this.leftData.indexOf(item.courseId);
        if (idx == -1) {
          this.leftData.push(item.courseId);
        }
      });
      this.batchOperate();
    },
    rightOpe() {
      this.rightDataQ.forEach((item) => {
        let idx = this.rightData.indexOf(item.courseId);
        if (idx == -1) {
          this.rightData.push(item.courseId);
        }
      });
      this.batchOperate();
    },
    // 添加移除操作
    operationLeft(id) {
      let idx = this.leftData.indexOf(id);
      if (idx == -1) {
        this.leftData.push(id);
      }
      this.batchOperate();
    },
    operationRight(id) {
      let idx = this.rightData.indexOf(id);
      if (idx == -1) {
        this.rightData.push(id);
      }
      this.batchOperate();
    },
    // 取消
    leftCancel(id) {
      let idx = this.leftData.indexOf(id);
      this.leftData.splice(idx, 1);
    },
    rightCancel(id) {
      let idx = this.rightData.indexOf(id);
      this.rightData.splice(idx, 1);
    },
    // 数据提交
    batchOperate() {
      if (this.leftData.length !== 0) {
        this.batchOperateLeft();
      }
      if (this.rightData.length !== 0) {
        this.batchOperateRight();
      }

      // this.dialogVisible = false;
      this.clear();
    },
    clear() {
      this.rightDataQ = [];
      this.leftDataQ = [];
      this.leftData = [];
      this.rightData = [];
      // this.schoolId = "";
    },
    // 数据提交接口
    batchOperateLeft() {
      let params = {
        courseIds: this.leftData,
        schoolId: this.schoolId,
        status: 0,
      };
      homeApi.batchOperate(params).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: "移除操作成功",
            type: "success",
          });
          this.courseListTrue();
          this.courseListFalse();
          this.clear();
        }
      });
    },
    batchOperateRight() {
      let params = {
        courseIds: this.rightData,
        schoolId: this.schoolId,
        status: 1,
      };
      homeApi.batchOperate(params).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: "加入操作成功",
            type: "success",
          });
          this.courseListTrue();
          this.courseListFalse();
          this.clear();
        }
      });
    },
    // 密码重置
    resetPassword(id) {
      let params = {
        userId: id,
        roleType: "school",
      };
      homeApi.resetPassword(params).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: "密码重置成功，重置后密码为000000",
            type: "success",
          });
        }
      });
    },
    // 基地校修改
    handleBaseChange(row) {
      let text = row.isPay === "1" ? "启用" : "取消";
      this.$confirm("是否" + text + "该基地校？","提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          debugger
          if (action !== 'confirm') {
            row.isPay = (row.isPay == 0 ? "1" : "0");
          }
          done();
        }
      }).then(() => {
        homeApi.changeBaseSchool({
          id: row.id,
          isPay: row.isPay,
          groupId: this.groupId
        }).then(() => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.schoolLists();
        });
      }).catch(() => {
      });
    },
  },
};
</script>
<style scoped>
.dlog_left {
  width: 600px;
  /* float: left; */

}
.dlog_right {
  width: 600px;
  /* float: right; */
}
.dlog_centent {
  /* float: left; */
  width: 160px;
  /* height: 100%; */
  display: flex;
  align-items: center;
  justify-content: space-around;
  /* background-color: red; */
}
.dialogFlex {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/courseMan/coursePoints.vue